import { partnerSharedService } from 'partner/shared/services';
import { useQuery } from 'react-query';
import {
  BusinessUnitFilterParams,
  JobTypeFilterParams,
} from 'partner/shared/services/partner-shared-service.types';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetFilterBusinessUnitsData = (params: BusinessUnitFilterParams) => {
  return useQuery({
    queryKey: QUERY_KEYS.businessUnits(),
    queryFn: async () =>
      await partnerSharedService.getFilterBusinessUnitsData({
        jobTypeIds: params.jobTypeIds,
      }),
  });
};

export const useGetFilterJobTypesData = (params: JobTypeFilterParams) => {
  return useQuery({
    queryKey: QUERY_KEYS.jobTypes(),
    queryFn: async () =>
      await partnerSharedService.getFilterJobTypesData({
        companyId: params.companyId,
        branchOfficeIds: params.branchOfficeIds,
        departmentIds: params.departmentIds,
      }),
  });
};

export const useGetFilterWorkersData = () => {
  return useQuery({
    queryKey: QUERY_KEYS.filterWorkersData(),
    queryFn: async () => await partnerSharedService.getFilterWorkersData(),
  });
};
